import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import sortLinks from '../common/utils/sortLinks';
import LinkItem from './components/LinkItem';
import LinkDropdown from './components/LinkDropdown';
export default function extendHeader() {
  extend(HeaderPrimary.prototype, 'items', function (items) {
    const allLinks = app.store.all('links');
    const links = allLinks.filter(link => !link.isChild());
    const addLink = parent => {
      const hasChildren = allLinks.some(link => link.parent() == parent);

      // If the link has no URL and no children, do not display it.
      if (!parent?.url() && !hasChildren) {
        return;
      }
      items.add(`link${parent?.id()}`, hasChildren ? LinkDropdown.component({
        link: parent
      }) : LinkItem.component({
        link: parent
      }));
    };
    sortLinks(links).map(addLink);
  });
}